import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import { DragAndDrop } from 'fine-uploader/s3.fine-uploader/s3.fine-uploader';

export default class Dropzone extends React.Component {
    componentDidMount() {
        this.registerDropzone();
    }

    componentDidUpdate() {
        this.registerDropzone();
    }

    componentWillUnmount() {
        this.dropzone && this.dropzone.dispose();
    }

    render() {
        return <div className="dropzone">{this.props.children}</div>;
    }

    registerDropzone() {
        this.dropzone && this.dropzone.dispose();

        // FIXME: don't use findDOMNode, see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
        const dropzoneEl = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

        this.dropzone = new DragAndDrop({
            allowMultipleItems: !!this.props.multiple,
            callbacks: {
                dropError: this.props.onDropError || (() => {}),
                // processingDroppedFiles: this.props.onProcessingDroppedFiles || (()=>{}),
                processingDroppedFilesComplete:
                    this.props.onProcessingDroppedFilesComplete || (() => {}),
            },
            classes: {
                dropActive: 'dropzone--active',
            },
            dropZoneElements: [dropzoneEl],
        });
    }
}

Dropzone.propTypes = {
    children: PropTypes.node,
    dropActiveClassName: PropTypes.string,
    multiple: PropTypes.bool,
    onDropError: PropTypes.func,
    onProcessingDroppedFiles: PropTypes.func,
    onProcessingDroppedFilesComplete: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/uploader/dropzone.jsx